import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "../App.css";

import nutrition1 from "../assets/nutrition.jpg";
import nutrition2 from "../assets/nutrition1.webp";
import nutrition3 from "../assets/nutrition2.webp";

const NutritionSwiper = () => {
  const images = [nutrition1, nutrition2, nutrition3, nutrition1, nutrition2, nutrition3];

  return (
    <Swiper
      modules={[Autoplay]}
      centeredSlides={true}     
      loop={true}
      autoplay={{ delay: 2000, disableOnInteraction: false }}
      
      /* ✅ Responsive Breakpoints */
      breakpoints={{
        0: { slidesPerView: 1, spaceBetween: 10 },      // mobile
        480: { slidesPerView: 1.2, spaceBetween: 15 },  // small phones
        768: { slidesPerView: 2, spaceBetween: 20 },    // tablets
        992: { slidesPerView: 3, spaceBetween: 30 },    // desktop
      }}

      className="horizontalImageSwiper"
    >
      {images.map((img, index) => (
        <SwiperSlide key={index} className="custom-horizontal-slide">
          <div className="slide-overlay-wrapper">
            <img
              src={img}
              alt={`Slide ${index + 1}`}
              className="horizontal-image"
            />
            <div className="side-dark-overlay"></div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default NutritionSwiper;